export function inputChangeValidation(e, index, type, phone) {
  switch (type) {
    case "phoneNumber":
    case "contactPhoneNumber":
      if (e.target.value > 25) return false;
      break;
    case "email":
    case "contactEmail":
      if (e.target.value > 100) return false;
      break;
    case "line1":
    case "line2":
    case "line3":
      if (e.target.value > 50) return false;
      break;
    case "zipCode":
      if (e.target.value > 20) return false;
      break;
    case "city":
      if (e.target.value > 100) return false;
      break;
    case "state":
      if (e.target.value.length > 100) return false;
      break;
    case "contributorName":
      break;
    case "fundName":
      if (e.target.value.length > 200) return false;
      break;
    case "percentage":
      if (e.target.value.length > 3) return false;
      break;
    case "firstName":
    case "middleName":
    case "lastName":
      if (e.target.value.length > 150) return false;
      break;
    case "charityName":
      if (e.target.value.length > 150) return false;
      break;
    case "contactFirstName":
    case "contactLatName":
      if (e.target.value > 100) return false;
      break;
    case "identificationNumber":
      if (e.target.value > 10) return false;
      break;
  }
}

export function inputBlurValidation(value, type, index, phone) {
  const emailCheck = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  const fundNameCheck = /(?:\w{2,})+/;
  switch (type) {
    case "phones":
    case "emailId":
      if (!emailCheck.test(value)) {
        return false;
      }
      break; 
    case "line1":
    case "line2":
    case "line3":
    case "zipcode":
      let trueCounter = 0;
      if(value !== null && value !== ""){
        if(index.country === "0"){
          if(value.length === 5){
            if(value.indexOf("-") === -1 ){
              trueCounter++;
            }
          }
          if(value.length === 10){
            if(value.indexOf("-") === 5 ){
              trueCounter++;
            }
            if(value.lastIndexOf("-") !== 5 ){
              trueCounter = 0;
            }
          }
        }else{
          if(value != null){
            if(value.length >= 1){
              trueCounter++;
            }
          }
        }
        if(trueCounter === 0){
          return false;
        }
        return true;
      }else{
        return false;
      }
    case "city":
    case "state":
      if (value.length < 2) return false;
    case "contributorName":
    case "percentage":
    case "name":
    case "firstName":
    case "lastName":
    case "charityName":
    case "contactPhoneNumber":
    case "identificationNumber":
      if (value === undefined || value == "") return false;
      else return true;
    case "fundName":
      if (
        value.includes("Trust") ||
        value.includes("Endowment") ||
        value.includes("Foundation")
      )
        return { contentValidation: true };
      if (value.startsWith("the", 1));
      if (value.endsWith("‘fund’ "));
      break;
  }
}
